import React, { useEffect, useState, useRef } from "react";
import { api, resolveImg } from "../../lib/api";
import { PageHead, Modal, Field, inp } from "../../components/admin/AdminBits";
import { Plus, Pencil, Trash2, Upload, GalleryHorizontal } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { image: "", title: "", subtitle: "", link: "", active: true, order: 99 };

export default function AdminSliders() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();
  const load = () => api.get("/admin/slides").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const f = e.target.files[0]; if (!f) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", f);
    try { const { data } = await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); setEdit((p) => ({ ...p, image: data.url })); }
    catch { toast.error("Грешка при качване"); } finally { setUploading(false); }
  };
  const save = async (e) => {
    e.preventDefault();
    try { if (edit.id) await api.put(`/admin/slides/${edit.id}`, edit); else await api.post("/admin/slides", edit); toast.success("Запазено"); setEdit(null); load(); }
    catch { toast.error("Грешка"); }
  };
  const del = async (id) => { if (window.confirm("Изтриване?")) { await api.delete(`/admin/slides/${id}`); load(); } };
  const toggle = async (s) => { await api.put(`/admin/slides/${s.id}`, { active: !s.active }); load(); };

  return (
    <div data-testid="admin-sliders">
      <PageHead title="Слайдери" desc="Активните слайдове се показват като тънък слайдер на началната страница (под отзивите)."
        action={<button onClick={() => setEdit({ ...EMPTY })} className="btn-gold px-4 py-2.5 rounded-sm text-sm flex items-center gap-2" data-testid="add-slide-btn"><Plus size={16} /> Нов слайд</button>} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((s) => (
          <div key={s.id} className="bg-white border border-stone overflow-hidden" data-testid={`slide-${s.id}`}>
            <div className="h-32 bg-stone overflow-hidden relative">
              {s.image && <img src={resolveImg(s.image)} alt="" className="w-full h-full object-cover" />}
              {!s.active && <span className="absolute top-2 left-2 bg-charcoal/70 text-white text-xs px-2 py-0.5">Неактивен</span>}
            </div>
            <div className="p-4">
              <p className="font-serif text-lg text-navy">{s.title || "(без заглавие)"}</p>
              <p className="text-sm text-charcoal/55">{s.subtitle}</p>
              <div className="flex items-center justify-between mt-3">
                <label className="flex items-center gap-2 text-xs text-navy"><input type="checkbox" checked={s.active} onChange={() => toggle(s)} className="accent-[#C6A45C]" data-testid={`slide-active-${s.id}`} /> Активен</label>
                <div className="flex gap-2"><button onClick={() => setEdit(s)} className="text-navy hover:text-gold"><Pencil size={15} /></button><button onClick={() => del(s.id)} className="text-charcoal/40 hover:text-red-500"><Trash2 size={15} /></button></div>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-charcoal/50 flex items-center gap-2"><GalleryHorizontal size={18} /> Няма слайдове.</p>}
      </div>
      {edit && (
        <Modal title={edit.id ? "Редакция на слайд" : "Нов слайд"} onClose={() => setEdit(null)}>
          <form onSubmit={save}>
            <Field label="Изображение">
              {edit.image && <img src={resolveImg(edit.image)} alt="" className="w-full h-32 object-cover border border-stone mb-2" />}
              <input ref={fileRef} type="file" accept="image/*" onChange={upload} className="hidden" />
              <button type="button" onClick={() => fileRef.current?.click()} className="btn-navy-outline px-4 py-2 rounded-sm text-sm flex items-center gap-2" data-testid="slide-upload-btn"><Upload size={14} /> {uploading ? "Качване..." : "Качи"}</button>
              <input value={edit.image} onChange={(e) => setEdit({ ...edit, image: e.target.value })} className={`${inp} mt-2`} placeholder="или URL" />
            </Field>
            <Field label="Заглавие"><input value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} className={inp} /></Field>
            <Field label="Подзаглавие"><input value={edit.subtitle} onChange={(e) => setEdit({ ...edit, subtitle: e.target.value })} className={inp} /></Field>
            <Field label="Линк"><input value={edit.link} onChange={(e) => setEdit({ ...edit, link: e.target.value })} className={inp} placeholder="/kartini" /></Field>
            <label className="flex items-center gap-2 text-sm text-navy mb-3"><input type="checkbox" checked={edit.active} onChange={(e) => setEdit({ ...edit, active: e.target.checked })} className="accent-[#C6A45C]" /> Активен</label>
            <button type="submit" className="btn-gold w-full py-2.5 rounded-sm" data-testid="save-slide-btn">Запази</button>
          </form>
        </Modal>
      )}
    </div>
  );
}
